// extracted by mini-css-extract-plugin
export default {"form":"queue-page_form__CipxS","result":"queue-page_result__7Razp"};